import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CookingStep } from '../../services/recipeTypes';
import { cookingStepSaveService } from '../../services/cookingStepSaveService';
import SortableList from '../../shared/dnd/SortableList';
import CookingStepListItem from './CookingStepListItem';

type CookingStepSortable = CookingStep & { id: string };

type CookingStepsListProps = {
    steps: CookingStep[];
    selectedStepId: string | null;
    onSelect: (stepId: string) => void;
};

const sortByOrder = (steps: CookingStep[]): CookingStep[] => (
    [...steps].sort((a, b) => (a.stepOrder || 0) - (b.stepOrder || 0))
);

const CookingStepsList: React.FC<CookingStepsListProps> = ({
    steps,
    selectedStepId,
    onSelect,
}) => {
    const { i18n } = useTranslation();
    const ordered = useMemo(
        () => sortByOrder(steps).filter((step): step is CookingStepSortable => Boolean(step.id)),
        [steps],
    );

    return (
        <aside className="cooking-steps__master">
            <div className="cooking-steps__master-header">
                {i18n.t('app.page.cookingStep.stepsCount', { count: ordered.length })}
            </div>
            <SortableList
                className="cooking-steps__list"
                items={ordered}
                onReorder={(orderedIds) => cookingStepSaveService.reorderSteps(orderedIds)}
                renderItem={(step, dragHandle, index) => (
                    <CookingStepListItem
                        step={step}
                        index={index}
                        selected={step.id === selectedStepId}
                        onSelect={onSelect}
                        dragHandle={dragHandle}
                    />
                )}
            />
        </aside>
    );
};

export default CookingStepsList;
